export const SET_CURRENCY = '@currency/SET_CURRENCY' as const;
